
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movies/[slug]",
      function () {
        return require("private-next-pages/movies/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movies/[slug]"])
      });
    }
  